import { useClerk } from "@clerk/react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuthStore } from "@/store/auth/auth.store";
import { useTenantStore } from "@/store/tenant/tenant.store";
import { websocketService } from "@/services/websocket.service";

export const useLogout = () => {
    const { signOut } = useClerk();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async () => {
            await signOut();
            useAuthStore.getState().setSession(null, async () => null);
            websocketService.disconnect();
            await queryClient.cancelQueries();
            queryClient.clear();
            useTenantStore.getState().clearTenantData();
        },
    });
};
